<template>
    <div class="animated fadeIn">
        <b-row
            ><b-col cols="12" sm="12" md="9">
                <h3 class="ml-2">Add Business Edit</h3>
            </b-col>
            <b-col cols="12" sm="12" md="3" class="pl-md-5"
                ><b-button
                    variant="primary"
                    class="back-button"
                    @click="
                        $router.push({
                            name: 'View Business Plan',
                            params: {
                                id: planDetails._id,
                            },
                        })
                    "
                    >Back
                </b-button>
                <b-button
                    size="sm"
                    variant="success"
                    class="refresh-btn-size ml-2"
                    @click="reloadData"
                    :disabled="isLoading"
                >
                    <span
                        v-if="isLoading"
                        class="fa fa-refresh fa-spin font-size-15"
                    />
                    <span
                        v-else
                        class="fa fa-refresh font-size-15"
                    /> </b-button
            ></b-col>
        </b-row>
        <b-card>
            <b-row class="my-2 mx-1"
                ><b-form-input
                    v-model="planDetails.planName"
                    placeholder="Enter Business Plan"
                ></b-form-input
            ></b-row>
            <b-row class="my-4 mx-1">
                <b-form-textarea
                    id="textarea"
                    v-model="planDetails.description"
                    placeholder="Enter something..."
                    rows="3"
                    max-rows="4"
                ></b-form-textarea
            ></b-row>
            <b-row>
                <b-col cols="12" sm="12" md="7">
                    <b-form-file
                        @change="readLogo"
                        :state="Boolean(selectedFile)"
                        placeholder="Subscription Logo"
                        drop-placeholder="Drop file here..."
                    ></b-form-file> </b-col
            ></b-row>
        </b-card>

        <b-row
            ><b-col cols="12" sm="12" md="7">
                <h3 class="ml-2">Add Subscription</h3>
            </b-col>
            <b-col cols="12" sm="12" md="3">
                <ValidationProvider
                    rules="required"
                    v-slot="{ errors }"
                    name="keys"
                >
                    <multiselect
                        class="perm_input"
                        :options="getSubscription"
                        placeholder="Select  Subscription"
                        label="planName"
                        :multiple="false"
                        track-by="id"
                        v-model="feature1"
                    ></multiselect>
                    <span class="validate-error">{{ errors[0] }}</span>
                </ValidationProvider>
            </b-col>
            <b-col cols="12" sm="12" md="2"
                ><b-button
                    :disabled="feature1 == ''"
                    variant="primary"
                    class="add-btn"
                    @click="addPlan"
                    >Add</b-button
                >
            </b-col>
        </b-row>
        <b-table
            :hover="true"
            :items="SubscriptionArrays"
            :striped="striped"
            :fields="Column1"
            :dark="false"
            :bordered="bordered"
            :small="small"
            :fixed="fixed"
            responsive="sm"
            id="subscription-table"
            :current-page="subscriptionCurrentPage"
            :per-page="subscriptionPerPage"
            thead-class="header"
            class="mt-3"
            show-empty
            :busy="isLoading"
            :no-border-collapse="true"
            @filtered="onSubscriptionFiltered"
        >
            <template slot="cell(empty)">
                <div v-if="isLoading" class="text-center">
                    <span><b>Loading...</b></span>
                </div>
                <div v-else class="text-center">No data available.</div>
            </template>
            <template slot-scope="data" slot="cell(action)">
                <div>
                    <b-button
                        size="sm"
                        class="mr-2 button-circle"
                        @click="onClickDelete(data.index)"
                        variant="danger"
                    >
                        <i class="fas fa-trash-alt"></i>
                    </b-button>
                </div> </template
        ></b-table>
        <b-pagination
            class="pagination-bar-wrapper end-pagination"
            v-if="subscriptionTotalRows > subscriptionPerPage"
            v-model="subscriptionCurrentPage"
            :total-rows="subscriptionTotalRows"
            :per-page="subscriptionPerPage"
            prev-text="Prev"
            next-text="Next"
            aria-controls="subscription-table"
            hide-goto-end-buttons
        ></b-pagination>
        <b-row
            ><b-col cols="12" sm="12" md="7">
                <h3 class="ml-2">Add Feature</h3>
            </b-col>
            <b-col cols="12" sm="12" md="3">
                <multiselect
                    class="perm_input"
                    :options="getFeatureList"
                    placeholder="Select Feature"
                    label="name"
                    track-by="name"
                    :multiple="false"
                    v-model="feature2"
                ></multiselect>
            </b-col>
            <b-col cols="12" sm="12" md="2"
                ><b-button
                    :disabled="feature2 == ''"
                    variant="primary"
                    class="add-btn"
                    @click="addPlan2"
                    >Add</b-button
                >
            </b-col>
        </b-row>
        <b-table
            :hover="true"
            :items="addFeatureToTable"
            :striped="striped"
            :fields="Column"
            :dark="false"
            :bordered="bordered"
            :small="small"
            :fixed="fixed"
            responsive="sm"
            id="feature-table"
            :current-page="featureCurrentPage"
            :per-page="featurePerPage"
            thead-class="header"
            class="mt-3"
            show-empty
            :busy="isLoading"
            :no-border-collapse="true"
            :sort-by.sync="sortBy"
            :sort-desc.sync="sortDesc"
            @filtered="onFeatureFiltered"
        >
            <template slot="cell(empty)">
                <div v-if="isLoading" class="text-center">
                    <span><b>Loading...</b></span>
                </div>
                <div v-else class="text-center">No data available.</div>
            </template>
            <template slot-scope="data" slot="cell(action)">
                <div>
                    <b-button
                        size="sm"
                        class="mr-2 button-circle"
                        @click="onClickDelete1(data.index)"
                        variant="danger"
                    >
                        <i class="fas fa-trash-alt"></i>
                    </b-button>
                </div>
            </template>
        </b-table>
        <b-pagination
            class="pagination-bar-wrapper end-pagination"
            v-if="featureTotalRows > featurePerPage"
            v-model="featureCurrentPage"
            :total-rows="featureTotalRows"
            :per-page="featurePerPage"
            prev-text="Prev"
            next-text="Next"
            aria-controls="feature-table"
            hide-goto-end-buttons
        ></b-pagination>
        <b-row class="mt-5">
            <b-col cols="12" sm="12" md="6" offset-md="3">
                <div class="d-flex justify-content-center gap-3 mt-2">
                    <button
                        type="button"
                        class="btn btn-lg btn-danger action-btn mb-5 "
                        @click="onClickClear"
                    >
                        Cancel
                    </button>
                    <button
                        type="button"
                        class="btn btn-lg btn-primary action-btn ml-3 mb-5 "
                        @click="updatePlan"
                    >
                        Update
                    </button>
                </div>
            </b-col>
        </b-row>
    </div>
</template>
<script>
import ebSelect from "@/components/FormElements/Select.vue";
import {
    ValidationProvider,
    ValidationObserver,
} from "vee-validate/dist/vee-validate.esm";
import { mapGetters, mapActions } from "vuex";

export default {
    components: {
        ebSelect,
        ValidationProvider,
    },
    data() {
        return {
            text: "",
            items: [],
            isLoading: false,
            addFeatureToTable: [],
            selectedFile: "",
            feature1: "",
            SubscriptionArrays: [],
            sortBy: "",
            Column1: [
                { label: "PlanName", key: "planName" },
                { label: "description", key: "planDescription" },
                { label: "Plan Price", key: "pricing" },
                { label: "action",  class: "center-price",key: "action" },
            ],
            Column: [
                { label: "featureName", key: "name" },
                {
                    label: "description",
                    key: "description",
                    class: "textAlignment",
                },
                {
                    label: "permissionAdded",
                    key: "permission",
                    formatter: "NoOfPermissions",
                },
                { label: "action", key: "action" },
            ],
            feature2: "",
            striped: false,
            bordered: true,
            small: false,
            fixed: false,
            subscriptionCurrentPage: 1,
            subscriptionPerPage: 10,
            subscriptionTotalRows: 0,
            featureCurrentPage: 1,
            featurePerPage: 10,
            featureTotalRows: 0,
            planDetails: "",
            sortDesc: "",
        };
    },
    computed: {
        ...mapGetters({
            getFeatureList: "businessPlan/GetfeatureList",
            getSubscriptionList: "businessPlan/GetsubscriptionList",
        }),
        getSubscription() {
            const data = this.getSubscriptionList;
            let newList = [];
            data.map((each) => {
                let arrayObj = {
                    id: each._id,
                    planName: each.planName,
                    planDescription: each.planDescription,
                    pricing: each.pricing.price,
                };
                newList.push(arrayObj);
            });
            return newList;
        },
    },
    methods: {
        ...mapActions({
            fetchFeatureList: "businessPlan/featureList",
            fetchSubscriptionList: "businessPlan/subscriptionPlan",
        }),
        async reloadData() {
            this.isLoading = true;
            let payload = {
                id: this.$route.params.id,
                plan_name: this.planDetails.plan_name,
                description: this.planDetails.description,
                image: this.selectedFile,
                features: this.addFeatureToTable,
                subscriptions: this.SubscriptionArrays,
            };
            await this.$store.dispatch(
                "businessPlan/updateBusinessPlan",
                payload,
            );
            this.isLoading = false;
        },

        onSubscriptionFiltered(list) {
            this.subscriptionTotalRows = list.length;
            this.subscriptionCurrentPage = 1;
        },
        onFeatureFiltered(list) {
            this.featureTotalRows = list.length;
            this.featureCurrentPage = 1;
        },
        onClickDelete(index) {
            this.$swal({
                title: "Are you sure?",
                text: "You want to delete this Subscription Plan?",
                type: "warning",
                showCancelButton: true,
                confirmButtonColor: "#d33",
                cancelButtonColor: "#3085d6",
            }).then((result) => {
                if (result.value) {
                    this.SubscriptionArrays.splice(index, 1)
                        .then((result) => {
                            this.$toasted.success(
                                "Subscription Plan Deleted Successfully",
                            );
                        })
                        .catch((error) => {
                            this.$toasted.error(error.message);
                        });
                }
            });
        },
        addPlan() {
            if (this.SubscriptionArrays.length > 0) {
                if (
                    this.SubscriptionArrays.some(
                        (e) => e.id == this.feature1.id,
                    )
                ) {
                    this.$toasted.error("Subscription Plan Already Added!");
                } else {
                    this.SubscriptionArrays.push(this.feature1);
                }
            } else {
                this.SubscriptionArrays.push(this.feature1);
            }
        },
        onClickClear() {
            this.$swal({
                title: "Are you sure?",
                text: "You want to Cancel!",
                type: "warning",
                showCancelButton: true,
                confirmButtonClass: "btn-danger",
                confirmButtonText: "Yes, Cancel!",
                cancelButtonText: "No don't Cancel!",
                closeOnConfirm: false,
                closeOnCancel: false,
            }).then(async (result) => {
                if (result.value) {
                    this.$swal({
                        timer: 1100,
                        title: "Cancelled!",
                        text: "Yes, Cancelled.Please Update...",
                    });
                    this.addFeatureToTable = [];
                    this.SubscriptionArrays = [];
                    this.planDetails.plan_name = "";
                    this.planDetails.description = "";
                }
            });
        },
        async updatePlan() {
            if (
                this.SubscriptionArrays.length == 0 &&
                this.addFeatureToTable.length == 0
            ) {
                this.$swal({
                    title: "Error",
                    text: "Please fill all required fields.",
                    type: "error",
                });
            } else if (this.SubscriptionArrays.length == 0) {
                this.$toasted.show("Select Subscription Plan", {
                    type: "info",
                    theme: "toasted-primary",
                    singleton: true,
                    duration: 1000,
                });
            } else if (this.addFeatureToTable.length == 0) {
                this.$toasted.show("Select Feature", {
                    type: "info",
                    theme: "toasted-primary",
                    singleton: true,
                    duration: 1000,
                });
            } else {
                let payload = {
                    id: this.$route.params.id,
                    plan_name: this.planDetails.plan_name,
                    description: this.planDetails.description,
                    image: this.selectedFile,
                    features: this.addFeatureToTable,
                    subscriptions: this.SubscriptionArrays,
                };
                await this.$store
                    .dispatch("businessPlan/updateBusinessPlan", payload)
                    .then((res) => {
                        if (res.status == 200) {
                            this.$swal({
                                title: "Success",
                                text: "Plan Updated Successfully",
                                type: "success",
                                timer: 1000,
                            });
                        }
                    });
                setTimeout(() => {
                    this.$router.push({ path: "/businessPlan" });
                }, 2000);
            }
            this.isLoading = true;
        },
        NoOfPermissions(value) {
            return value.length;
        },
        onClickDelete1(index) {
            this.$swal({
                title: "Are you sure?",
                text: "You want to delete this Feature?",
                type: "warning",
                showCancelButton: true,
            }).then((result) => {
                if (result.value) {
                    this.addFeatureToTable
                        .splice(index, 1)
                        .then((result) => {
                            this.$toasted.success(
                                "Feature Deleted Successfully",
                            );
                        })
                        .catch((error) => {
                            this.$toasted.error(error.message);
                        });
                }
            });
        },
        addPlan2() {
            if (this.addFeatureToTable.length > 0) {
                if (
                    this.addFeatureToTable.some(
                        (e) => e._id == this.feature2._id,
                    )
                ) {
                    this.$toasted.error("Feature Already Added!");
                } else {
                    this.addFeatureToTable.push(this.feature2);
                }
            } else {
                this.addFeatureToTable.push(this.feature2);
            }
        },
        async fetchBusinessPlanDetails() {
            const data = await this.$store.dispatch(
                "businessPlan/businessPlanDetails",
                {
                    id: this.$route.params.id,
                },
            );
            this.planDetails = data?.data?.response;
            this.addFeatureToTable = data?.data?.response.features;
            this.SubscriptionArrays = data?.data?.response.subscriptions;
            this.selectedFile = data?.data?.response.image;

            this.featureTotalRows = this.addFeatureToTable?.length || 0;
            this.featureCurrentPage = 1;
            this.subscriptionTotalRows = this.SubscriptionArrays?.length || 0;
            this.subscriptionCurrentPage = 1;
        },
        async fetchFeatureDetails() {
            await this.$store.dispatch("businessPlan/featureListDetail", {
                id: this.$route.params.id,
            });
        },
        readLogo(e) {
            const reader = new FileReader();
            reader.readAsDataURL(e.target.files[0]);
            reader.onload = () => {
                this.uploadImage(reader.result);
            };
            reader.onerror = (err) => {
                console.error("reader : ", err);
            };
        },
        // upload images to the S3 bucket
        async uploadImage(image) {
            let dataobj = {
                image: image,
                key: (
                    Date.now().toString(36) +
                    Math.random().toString(36).substr(2, 5)
                ).toLowerCase(),
                isPublic: true,
                replaceExisting: true,
                basePath: "tenant",
            };
            this.showCustomToast();
            await this.$store
                .dispatch("inventory/uploadImageToStorage", dataobj)
                .then((res) => {
                    if (res) {
                        this.clearCustomToast();
                        this.selectedFile = res.data.fileUrl;
                    }
                })
                .catch((error) => {
                    this.clearCustomToast();
                    this.$toasted.error(
                        "Image not uploaded..please try again!",
                    );
                });
        },
        showCustomToast() {
            this.$toasted.show("Uploading...", {
                type: "info",
                theme: "toasted-primary",
                singleton: true,
                duration: 1000000,
            });
        },
        clearCustomToast() {
            this.$toasted.clear();
        },
    },
    watch: {
        addFeatureToTable: {
            handler() {
                this.featureTotalRows = this.addFeatureToTable?.length || 0;
                const maxPage = Math.max(
                    1,
                    Math.ceil(this.featureTotalRows / this.featurePerPage),
                );
                if (this.featureCurrentPage > maxPage) {
                    this.featureCurrentPage = maxPage;
                }
            },
            deep: true,
        },
        SubscriptionArrays: {
            handler() {
                this.subscriptionTotalRows =
                    this.SubscriptionArrays?.length || 0;
                const maxPage = Math.max(
                    1,
                    Math.ceil(
                        this.subscriptionTotalRows / this.subscriptionPerPage,
                    ),
                );
                if (this.subscriptionCurrentPage > maxPage) {
                    this.subscriptionCurrentPage = maxPage;
                }
            },
            deep: true,
        },
    },
    mounted() {
        this.isLoading = true;
        this.fetchBusinessPlanDetails();
        this.fetchFeatureDetails();
        this.fetchFeatureList();
        this.fetchSubscriptionList({
            scope: "TENANT",
        });
        this.isLoading = false;
    },
};
</script>
<style>
.refresh-button {
    font-size: large;
    width: 42px;
    height: 35px;
    padding: 0px;
    margin-left: 5px;
    margin-right: 15px;
}
.back-button {
    height: 38px;
    width: 98px;
}
.add-btn {
    margin-left: -9px;
    height: 38px;
    width: 98px;
}

.feature-select {
    margin-left: 50px;
}
td.textAlignment {
    text-align: justify !important;
    white-space: pre-wrap;
}
.refresh-btn-size {
    width: 42px;
    height: 35px;
}
.font-size-15 {
    font-size: 15px;
}
.end-pagination {
  display: flex;
  justify-content: flex-end;
}
.action-btn {
  width: 25px;   
  padding: 8px 12px;
}

</style>
